import wayfindingService from '@/services/WayfindingService'
import geoLocationService from '@/services/GeoLocationService'

export const wayfinding = () => {
  return {
    namespaced: true,
    state: {
      title: '',
      address: '',
      city: '',
      loading: false,
      open: false,
      seenLocationModal: false,
      acceptedGeolocationSharing: false,
      start: {
        lng: undefined,
        lat: undefined
      },
      destination: {
        lng: undefined,
        lat: undefined
      },
      travelOptions: []
    },
    mutations: {
      SET_ADDRESS (state, address) {
        state.address = address
      },
      SET_CITY (state, city) {
        state.city = city
      },
      SET_DESTINATION (state, location) {
        state.destination = location
        state.destination.lng = location.lng
        state.destination.lat = location.lat
      },
      SET_LOADING (state, value) {
        state.loading = value
      },
      SET_OPEN (state, value) {
        state.open = value
      },
      SET_START (state, location) {
        state.start.lng = location.longitude
        state.start.lat = location.latitude
      },
      SET_TITLE (state, title) {
        state.title = title
      },
      SET_TRAVEL_OPTIONS (state, travelOptions) {
        state.travelOptions = travelOptions
      },
      SET_SEEN_LOCATION_MODAL (state, bool) {
        state.seenLocationModal = bool
      },
      SET_GEOLOCATION_SHARING (state, bool) {
        state.acceptedGeolocationSharing = bool
        state.seenLocationModal = true
      }
    },
    actions: {
      getTravelOptions ({ state, commit }) {
        const payload = {
          startLongitude: state.start.lng,
          startLatitude: state.start.lat,
          endLongitude: state.destination.lng,
          endLatitude: state.destination.lat
        }
        // console.log('payload: ', payload, state)

        return wayfindingService.getTravelOptions(payload)
          .then(travelOptions => {
            // Temp solution till response returns array
            travelOptions = Object.keys(travelOptions).map(key => {
              return travelOptions[key]
            })

            commit('SET_TRAVEL_OPTIONS', travelOptions)
          })
      },
      getCurrentLocation ({ commit }, options) {
        return geoLocationService.getCurrentLocation(options)
          .then(position => {
            commit('SET_START', position.coords)
          })
          .catch(error => {
            throw new Error(error.message)
          })
      },
      setGeolocationSharing ({ commit }, bool) {
        commit('SET_GEOLOCATION_SHARING', bool)
      },
      openWayfinding ({ commit, dispatch }, payload) {
        commit('SET_ADDRESS', payload.address)
        commit('SET_CITY', payload.city)
        commit('SET_DESTINATION', payload.destination)
        commit('SET_LOADING', true)
        commit('SET_TITLE', payload.title)
        commit('SET_OPEN', true)
        commit('SET_SEEN_LOCATION_MODAL', true)
        commit('SET_GEOLOCATION_SHARING', true)

        dispatch('getCurrentLocation')
          .then(() => {
            dispatch('getTravelOptions')
          })
          .finally(() => {
            commit('SET_LOADING', false)
          })

      }
    }
  }
}
